import React, { useEffect } from 'react'

import Modal from '@components/Modal'
import { successMessages } from '@constants/feedbackMessages'
import { Dialog } from '@headlessui/react'
import { AddTutorialRequest } from '@models/tutorial.model'
import { tutorialApi } from '@services/TutorialApi'
import { closeModal } from '@store/ducks/modal'
import { notificationCreators } from '@store/ducks/notification'
import { useAppDispatch } from '@store/hooks'
import { getCssStyle, pixelsToRem } from '@utils/helpers/styleHelpers'

import TutorialForm from '../TutorialForm'

const styles = {
	container:
		'relative inline-block align-bottom bg-white rounded-lg pl-10 pr-10 pt-6 pb-9 text-left overflow-hidden shadow-xl transform transition-all my-8 sm:align-middle',
	title: 'text-lg leading-6 font-medium text-gray-900',
	subTitle: 'text-gray-500 mt-1',
}

export default function AddTutorial() {
	const dispatch = useAppDispatch()

	const [addTutorial, { isLoading, isSuccess }] = tutorialApi.useAddMutation()

	useEffect(() => {
		if (isSuccess) {
			dispatch(closeModal())
			dispatch(notificationCreators.show(successMessages.storedTutorial))
		}
	}, [isSuccess, dispatch])

	return (
		<Modal name='addTutorial'>
			<Dialog.Panel
				style={getCssStyle(
					{ name: 'overflowY', value: 'auto' },
					{ name: 'maxWidth', value: pixelsToRem(630) },
					{ name: 'maxHeight', value: pixelsToRem(640) },
					{ name: 'width', value: '100%' }
				)}
				className={`${styles.container} modal-scroll`}
			>
				<p className={styles.title}>Adicionar Tutorial</p>
				<p className={styles.subTitle}>
					Um vídeo curto do YouTube e quem deve vê-lo.
				</p>

				<TutorialForm
					isLoading={isLoading}
					submitLabel='Adicionar Tutorial'
					onCancel={() => dispatch(closeModal())}
					onSubmit={(payload: AddTutorialRequest) => addTutorial(payload)}
				/>
			</Dialog.Panel>
		</Modal>
	)
}
